export default "__VITE_ASSET__Bn4tx6JZ__"